"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { track } from "@lib/track";

export default function PageViewTracker() {
  const pathname = usePathname();

  useEffect(() => {
    const title = typeof document !== "undefined" ? document.title : "";
    track(
      "page_view",
      { label: pathname, component: "WorkWithMeLayout" },
      {
        event: "page_view",
        label: pathname,
        meta: { title },
      }
    );
  }, [pathname]);

  return null;
}
